import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { Button, Icon, Popup } from "semantic-ui-react";
import PropTypes from "prop-types";
import "../styles/Clipboard.less";

class Clipboard extends Component {
  contextRef = createRef();

  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    };
  }

  clicked = () => {
    const { data, animationTime } = this.props;
    const dummy = document.createElement("input");
    document.body.appendChild(dummy);
    dummy.setAttribute("value", data);
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    if (animationTime) {
      this.setState({ clicked: true });
      setTimeout(() => {
        this.setState({ clicked: false });
      }, animationTime);
    }
  };

  render() {
    const {
      size,
      inverted,
      content,
      clickedContent,
      className,
      circular,
      icon,
      enablePopup,
      contentPopup,
      clickedContentPopup,
      classNamePopup,
      hide,
      t,
    } = this.props;
    const { clicked } = this.state;
    if (hide) {
      return <></>;
    }
    let displayContent =
      content === undefined ? (
        <Icon name="clipboard" inverted={inverted === undefined ? true : inverted} color="black" />
      ) : (
        content
      );
    let popupContent = contentPopup !== undefined ? contentPopup : t("clickCopy");
    if (clicked) {
      displayContent =
        clickedContent === undefined && content === undefined ? (
          <Icon name="clipboard check" inverted={inverted === undefined ? true : inverted} color="black" />
        ) : (
          clickedContent || content
        );
      popupContent = clickedContentPopup !== undefined ? clickedContentPopup : t("copied");
    }
    return (
      <>
        <Popup
          content={popupContent}
          className={classNamePopup === undefined ? "clipboardPopup" : classNamePopup}
          disabled={enablePopup !== undefined ? !enablePopup : false}
          mouseEnterDelay={300}
          on="hover"
          size="mini"
          position="top center"
          trigger={
            <Button
              ref={this.contextRef}
              icon={icon === undefined ? true : icon}
              circular={circular === undefined ? false : circular}
              className={className}
              inverted={inverted === undefined ? true : inverted}
              compact
              size={size}
              content={displayContent}
              onClick={this.clicked}
            />
          }
        />
      </>
    );
  }
}
Clipboard.propTypes = {
  data: PropTypes.string.isRequired, // data to copy to clipboard
  className: PropTypes.string, // className added to the button
  animationTime: PropTypes.number, // delay before going back to normal content
  enablePopup: PropTypes.bool, // show popup
  contentPopup: PropTypes.string, // normal popup content (mouse over)
  clickedContentPopup: PropTypes.string, // popup content on clicked
  classNamePopup: PropTypes.string, // custom classname for popup
  hide: PropTypes.bool, // hide clipboard button
  circular: Button.propTypes.circular,
  icon: Button.propTypes.icon,
  size: Button.propTypes.size,
  inverted: Button.propTypes.inverted,
  content: Button.propTypes.content,
  clickedContent: Button.propTypes.content,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Clipboard);
